/* Softari — comportamento dos blocos próprios da página de produto.
   Cada parte é independente e falha aberta: um seletor ausente não derruba as outras. */
(function () {
  'use strict';
  if (window.SftrPdp) return;
  window.SftrPdp = true;

  function cada(sel, fn) {
    document.querySelectorAll(sel).forEach(function (el) {
      try { fn(el); } catch (e) { if (window.console) console.warn('sftr-pdp', sel, e); }
    });
  }

  /* ---------------- contagem regressiva da oferta ---------------- */
  function timer(el) {
    var valor = el.querySelector('[data-sftr-timer-valor]');
    if (!valor) return;
    var total = Math.max(1, parseInt(el.getAttribute('data-minutos'), 10) || 5) * 60;
    var resta = total;
    function pinta() {
      var m = Math.floor(resta / 60), s = resta % 60;
      valor.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    pinta();
    setInterval(function () { resta = resta > 0 ? resta - 1 : total; pinta(); }, 1000);
  }

  /* ---------------- datas de entrega ---------------- */
  var DIAS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MESES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  function ordinal(n) {
    var r = n % 100;
    if (r >= 11 && r <= 13) return n + 'th';
    return n + ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
  }
  function formata(d) { return DIAS[d.getDay()] + ', ' + MESES[d.getMonth()] + ' ' + ordinal(d.getDate()); }
  function datas(el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 0, max = parseInt(el.getAttribute('data-max'), 10) || min;
    var hoje = new Date(), a = new Date(hoje), b = new Date(hoje);
    a.setDate(hoje.getDate() + min); b.setDate(hoje.getDate() + max);
    el.innerHTML = el.innerHTML.replace(/\[start_date\]/g, formata(a)).replace(/\[end_date\]/g, formata(b));
  }

  /* ---------------- carrossel de depoimentos ---------------- */
  function depoimentos(el) {
    var trilho = el.querySelector('[data-trilho]'), pontos = el.querySelector('[data-pontos]');
    if (!trilho) return;
    var itens = Array.prototype.slice.call(trilho.children);
    if (!pontos) return;
    pontos.innerHTML = '';
    if (itens.length < 2) return;
    var botoes = itens.map(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sftr-depoimentos__ponto';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () { trilho.scrollTo({ left: itens[i].offsetLeft - itens[0].offsetLeft, behavior: 'smooth' }); });
      pontos.appendChild(b);
      return b;
    });
    function ativo() {
      var i = Math.round(trilho.scrollLeft / Math.max(1, itens[0].offsetWidth + parseFloat(getComputedStyle(trilho).columnGap || 0)));
      i = Math.max(0, Math.min(itens.length - 1, i));
      botoes.forEach(function (b, k) { b.classList.toggle('is-active', k === i); b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      trilho.style.height = itens[i].querySelector('.sftr-depoimentos__cartao').offsetHeight + 'px';
    }
    var t;
    trilho.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(ativo, 60); }, { passive: true });
    window.addEventListener('resize', ativo);
    itens.forEach(function (it) { var img = it.querySelector('img'); if (img && !img.complete) img.addEventListener('load', ativo); });
    ativo();
  }

  /* ---------------- barra fixa de compra ---------------- */
  function barraFixa(el) {
    var alvo = document.querySelector('product-info .product-form__buttons, .product__info-container .product-form__buttons');
    if (!alvo) return;
    document.body.appendChild(el);
    var info = document.querySelector('.product__info-container') || document.querySelector('product-info');
    function confere() {
      var r = alvo.getBoundingClientRect();
      var passou = r.bottom < 0;
      el.hidden = !passou;
      document.body.classList.toggle('sftr-barra-fixa-aberta', passou);
    }
    window.addEventListener('scroll', confere, { passive: true });
    window.addEventListener('resize', confere);
    confere();
    var botao = el.querySelector('[data-sftr-barra-botao]');
    if (botao && info) botao.addEventListener('click', function () {
      var y = info.getBoundingClientRect().top + window.scrollY - 20;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
    var sel = el.querySelector('[data-sftr-barra-variante]');
    if (sel) sel.addEventListener('change', function () {
      var op = sel.options[sel.selectedIndex];
      var venda = el.querySelector('[data-venda]'), cheio = el.querySelector('[data-cheio]');
      if (venda && op) venda.textContent = op.getAttribute('data-preco');
      if (cheio && op && op.getAttribute('data-cheio')) cheio.textContent = op.getAttribute('data-cheio');
      var campo = document.querySelector('product-info form[action*="/cart/add"] [name="id"]');
      if (campo) campo.value = sel.value;
    });
  }

  /* ---------------- ponte: widget de ofertas → gaveta do Dawn ---------------- */
  document.addEventListener('ewc:cart:added', function () {
    var gaveta = document.querySelector('cart-drawer');
    if (!gaveta || typeof gaveta.renderContents !== 'function') {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(raiz + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (secoes) {
        gaveta.classList.remove('is-empty');
        gaveta.renderContents({ id: null, sections: secoes });
      })
      .catch(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; });
  });

  function iniciar() {
    cada('[data-sftr-timer]', timer);
    cada('[data-sftr-datas]', datas);
    cada('[data-sftr-depoimentos]', depoimentos);
    cada('[data-sftr-barra-fixa]', barraFixa);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
